import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PtReservationService {
  private api = inject(ApiService);

  get(id: number) { return this.api.get(`/reservation/record/${id}`); }
  getAll(studioId: number) { return this.api.get(`/reservation/record/studio/${studioId}`); }
  downloadCsv(from: string, to: string) {
    return firstValueFrom(this.api.getHttp().get(`${this.api.base}/reservation/record/csv`, {
      params: { from, to }, responseType: 'text', observe: 'response',
    }));
  }
  // 旧版 factories/pt-reservation.js:49-66: HTTP 200 なら success=false も含め応答全体を画面へ返し、画面側でFlashを出す
  async create(json: any): Promise<any> {
    try {
      return await firstValueFrom(this.api.postRaw('/reservation/record/new', json));
    } catch (err: any) {
      if (err?.status !== 401) this.api.getRouter().navigate(['/error']);
      throw err;
    }
  }
  dummy(json: any) { return this.api.post('/reservation/record/dummy', json); }
  update(json: any) { return this.api.post('/reservation/record', json); }
  remove(json: any) { return this.api.post('/reservation/record/remove', json); }
  destroy(json: any) { return this.api.post('/reservation/record/destroy', json); }
}
